export default __webpack_public_path__ + "static/media/attach.678faa1e.svg";